import React from 'react'

const SvgSemaphoreNegativeBw = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 17.81 17.81"
        {...props}
    >
        <defs>
            <linearGradient
                id="semaphore_negative_bw_svg__a"
                x1={15.2}
                y1={16.25}
                x2={2.61}
                y2={28.85}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#b0adad" />
                <stop offset={1} stopColor="#e4e4e5" />
            </linearGradient>
            <linearGradient
                id="semaphore_negative_bw_svg__b"
                x1={6.28}
                y1={25.06}
                x2={11.54}
                y2={19.81}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#010101" stopOpacity={0.75} />
            </linearGradient>
        </defs>
        <g data-name="Vrstva 2">
            <g data-name="Vrstva 1">
                <g data-name="Vrstva 2">
                    <circle
                        cx={8.91}
                        cy={8.91}
                        r={8.91}
                        style={{
                            fill: "url(#semaphore_negative_bw_svg__a)",
                        }}
                    />
                    <image
                        width={67}
                        height={33}
                        transform="matrix(.16 0 0 .16 3.7 6.52)"
                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAhCAYAAACC9hYiAAAACXBIWXMAAEZvAABGbwGibm1yAAACpUlEQVRoQ+2ZYW+bMBCGHxJIWaapayet6qT9/9+2fWg1daRuCKEfzjfOxoF+6kyaV7KIncTyPdwZ31H0fc9FonLuB1VdF9FQ3M9RwR1unXvTHS9SnuEB2Eb0eQnqGaDo534KTADDQFgB6+gaw8lZvWlHoIuuSShxmBSI8SWwMa0khJK7LIQDsDft4MdHMP55hveKNVABNfDZt63vb/z3Nmxykw2LDjHeATug8c0BLdDF3mE9Q2FsEAhfgRvfviBAKsQ79Pe5SY07IgY74Al49E2/0zYJY8UA4wa4B+6AWz92Rf6hoiHygnjCA3IjQQC9IB4zsqGEYONUz9giMO6An8B34BqZ1IZKjtIQccAf5Cbi+399WwNFVdeFDZV4A135sRoJjVsExA8EzpYBRo5A9AnSIfuEgrAeUjKEeqA4TKx36CZ6jYD4hsA4OVkmOiJPjE++3yB2xA+BdJh4xWeMCtkjagTCFpm0JH/POPj+M7L+K8Se+MwUSGHYx6WFomD07FEik+YIQqV7gJ6NFEDq4FiY38/mJjGcgvGEOUkNS613VqdiP56gOHHNTVPrnIWS80b47rrAMDoFw6a/2k9dc9PUOmObRprbQONU2E6YM5B4vW9aq8KwBtrJNA3WVFif37Ob0X+SPWdoqq41jBScAJL1DAuhY0hqNAXWE91STqA73xxiR4sp7pDwlhQMWwdoCJOdZ5aVmzwi69c6xp6hsDMJAwaqWgd4IEx2lpi1/kbsePJjB8TOkUqQ6nFV19YrlKrWATTZWWo94xdizw7jHVOVLp1k7yfRypBjSH+XXulqEPtGVS4Yw1DPaPxYixRDzqkGaveNQPGrAs1Sz7463jo32jfiDVSJ2pA5y/cmqT9d3qgZJWFYffh3rR9VOR+r310XGEav9dhCscL4lqoAAAAASUVORK5CYII="
                        style={{
                            opacity: 0.25,
                            isolation: "isolate",
                        }}
                    />
                    <path
                        style={{
                            fill: "#fff",
                        }}
                        d="M4.87 7.8h8.08v2.44H4.87z"
                    />
                    <path
                        style={{
                            fill: "url(#semaphore_negative_bw_svg__b)",
                            opacity: 0.25,
                            isolation: "isolate",
                        }}
                        d="M4.87 7.8h8.08v2.44H4.87z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default SvgSemaphoreNegativeBw;